@if (asTemplate; as template) {
  <ng-template [ngTemplateOutlet]="template"></ng-template>
}
